export enum CATEGORY_MESSAGES_STUDENTS_IDS {
    BASIC = 8,
    ACCEPTED = 60,
    REFUSED = 61,
    SENDING_APPLICATION=62,
    SENDING_NOTIFICATIONS=63
  }
  export enum APPLICATION_STATUS{
    BASIC = "6",
    INITIAL_DRAFT_APPLY="-2",
    INITIAL_UNDER_REVIEW="-1",
    SENT_UNDER_REVIEW="1",
    ACCEPTED="2",
    REFUSED="3",
    FEEDBACK="4",
    PENDING_FOR_FEES="7",
    PULLED_CREDIT_SYSTEM="8",
    WAITING_LIST="10"
  }

  export const AppStatusEnum = Object.freeze({
  DRAFT_APPLY: "0",
  INITIAL_DRAFT_APPLY: "-2",
  UNDER_REVIEW: "1",
  INITIAL_UNDER_REVIEW: "-1",
  ACCEPTED: "2",
  REJECTED: "3",
  TO_BE_COMP: "4",
  ACCEPT_CANDIDATE: "5",
  REJECT_CANDIDATE: "6",
  SEND_NO_FEES: "7",
  TRANSFERRED: "8",
  REFUSED_AS_OTHER_ACCEPTED: "9",
  WAITING: "10",
});

export function AppStatusTranslationMap (vm) {
  return {
    [AppStatusEnum.DRAFT_APPLY]: vm.$t("DRAFT_STATUS"),
    [AppStatusEnum.INITIAL_DRAFT_APPLY]: vm.$t("INITIAL_DRAFT_STATUS"),
    [AppStatusEnum.UNDER_REVIEW]: vm.$t("UNDER_REVIEW_STATUS"),
    [AppStatusEnum.INITIAL_UNDER_REVIEW]: vm.$t("INITIAL_UNDER_REVIEW_STATUS"),
    [AppStatusEnum.ACCEPTED]: vm.$t("ACCEPTED_STATUS"),
    [AppStatusEnum.REJECTED]: vm.$t("REFUSED_STATUS"),
    [AppStatusEnum.TO_BE_COMP]: vm.$t("TO_BE_COMPLETED"),
    [AppStatusEnum.ACCEPT_CANDIDATE]: vm.$t("RECOMMENDED_ACCEPTED_STATUS"),
    [AppStatusEnum.REJECT_CANDIDATE]: vm.$t("RECOMMENDED_REFUSED_STATUS"),
    [AppStatusEnum.SEND_NO_FEES]: vm.$t("UNDER_REVIEW_NOFEES_STATUS"),
    [AppStatusEnum.TRANSFERRED]: vm.$t("PULLED_TO_SIS_STATUS"),
    [AppStatusEnum.REFUSED_AS_OTHER_ACCEPTED]: vm.$t("REFUSED_AS_ACCEPTED_IN_OTHER_STUDENTS"),
    [AppStatusEnum.WAITING]: vm.$t("WAITING_LIST"),
  };
}